
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface AirportStats {
  airport_name: string;
  review_count: number;
  average_score: number;
  hand_check_success_rate: number;
}

interface AirportStatsTableProps {
  airportStats: AirportStats[];
}

export default function AirportStatsTable({ airportStats }: AirportStatsTableProps) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Airport</TableHead>
          <TableHead className="text-right">Reviews</TableHead>
          <TableHead className="text-right">Avg Score</TableHead>
          <TableHead className="text-right">Hand Check Success</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {airportStats.map((stat) => (
          <TableRow key={stat.airport_name}>
            <TableCell>{stat.airport_name}</TableCell>
            <TableCell className="text-right">{stat.review_count}</TableCell>
            <TableCell className="text-right">{stat.average_score.toFixed(1)}</TableCell>
            <TableCell className="text-right">{stat.hand_check_success_rate.toFixed(1)}%</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
